import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const GestaoDeLeitosRoute = props => {
  const { isLeitos, isLeitosUai, isLeitosUaa, isLeitosCapsAd, isTodosLeitosConsulta } = useContext(UserContext);

  const hasLeitosAccess = isLeitos || isLeitosUai || isLeitosUaa || isLeitosCapsAd || isTodosLeitosConsulta;

  if (hasLeitosAccess) {
    return <Route {...props} />;
  } else if (!hasLeitosAccess) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default GestaoDeLeitosRoute;
